import { InstructorPageWrapper, withHTMLHeadSEO } from 'components/common';
import EditAssignment from 'components/features/assignment/edit-assignment/EditAssignment';

const EditAssignmentPage = () => <InstructorPageWrapper>{() => <EditAssignment />}</InstructorPageWrapper>;

export { EditAssignmentPage as BaseEditAssignmentPage };
export default withHTMLHeadSEO({ title: 'Edit Assignment' })(EditAssignmentPage);
